import { useQuery } from 'react-query';
import API from './utils/api';
import ENDPOINTS from './utils/endpoints';
import { TimeRequestOptionsDto } from '../models/time-request.dto';

// Pay periods and overtime an employee can request work time or overtime for
export function useGetTimeRequestOptions(employeeId?: number, enabled = true) {
    const { data, isLoading, error } = useQuery<{ data: TimeRequestOptionsDto }, Error>(
        [ENDPOINTS.HR.TIME_REQUEST_OPTIONS.GET, employeeId],
        () => API.HrAPI.getTimeRequestOptions(employeeId ? { employeeId } : undefined),
        { enabled },
    );

    return { data: data?.data, isLoading, error };
}
